import { OptionType } from './types';

export const getOptionLabel = (option: OptionType, t: (key: string) => string): {name: string, complement: string} => option.label;

export const getOptionTracking = (option: OptionType): string => option.label;

export const getOptionValue = (option: OptionType): string => option.value;
